var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header navbar navbar-fixed-top"},[_c('div',{staticClass:"page-header-inner"},[_c('span',{staticStyle:{"color":"white","size":"14px"}},[_vm._v(" 是否拥有权限 SCM_M60_FINISHED_GOODS_MASTER_DATA_SEARCH: "+_vm._s(_vm.auth.SCM_M60_FINISHED_GOODS_MASTER_DATA_SEARCH)+", 是否是管理员: "+_vm._s(_vm.isAdmin)+", ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }